<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme">
            <div ot>不显示间断点: {{ sliderStepValue1 }}</div>
            <div ot>显示间断点: {{ sliderStepValue2 }}</div>
        </ot-row-group>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-slider :theme="$otTheme" v-model="sliderStepValue1" :step="4"></ot-slider>
            <ot-slider :theme="$otTheme" v-model="sliderStepValue2" :step="10" showStep></ot-slider>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            sliderStepValue1: 25,
            sliderStepValue2: 0,
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cdiv%20ot%3E%E4%B8%8D%E6%98%BE%E7%A4%BA%E9%97%B4%E6%96%AD%E7%82%B9%3A%20%7B%7B%20sliderStepValue1%20%7D%7D%3C%2Fdiv%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cdiv%20ot%3E%E6%98%BE%E7%A4%BA%E9%97%B4%E6%96%AD%E7%82%B9%3A%20%7B%7B%20sliderStepValue2%20%7D%7D%3C%2Fdiv%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-slider%20v-model%3D%22sliderStepValue1%22%20%3Astep%3D%224%22%3E%3C%2Fot-slider%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-slider%20v-model%3D%22sliderStepValue2%22%20%3Astep%3D%2210%22%20showStep%3E%3C%2Fot-slider%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20sliderStepValue1%3A%2025%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20sliderStepValue2%3A%200%2C%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
};
</script>
